module.exports = __webpack_public_path__ + "img/logo-2.7d55d02a.png";